export enum SelectedSite {
    AnnArbor = "86_lAwVQRMqzU7Q-uFKzFg",
    Dearborn = "V0bYQ-pqT6SaatB_vBaUBQ",
    Flint = "rlsox-NGSQOhN5fNYa6h_A"
}


export interface RootState { 
    version: string;
    error: boolean;
    showSidebar: boolean;
    selectedSite: SelectedSite,
    playAlertBell: boolean
}

export const API_ROOT = process.env.VUE_APP_GLOBAL_API_ROOT;